module.exports = __webpack_public_path__ + "img/ARCS.4fd2bfbf.png";